import numeral from 'numeral';

function numeralFormat(number, type) {
  //type : number of zero following the dot
  if (isNaN(number)) return '0.00';

  switch (type) {
    case 1:
      number = numeral(number).format('0.0');
      break;
    case 2:
      number = numeral(number).format('0.00');
      break;
    case 3:
      number = numeral(number).format('0.000');
      break
    default:
      number = numeral(number).format('0.000');
      break;
  }

  if (number < 1) {
    return number.toString().substr(1);
  } else {
    return number;
  }
}

export { numeralFormat };
